/** @jsxImportSource @emotion/react */
import React, { PropsWithChildren } from "react";
import { CSVLink } from "react-csv";
import styled from "@emotion/styled";
import { Text } from "../general/Text";
import { css } from "@emotion/react";
import DownloadIcon from "../../img/download/DownloadItem.svg?react";
import { GlobalStore } from "../../store/global/GlobalStore";
import { useIsMobile } from "../../hooks/useDeviceType";

interface DownloadCSVButtonProps {
  data: Array<object>;
  filename: string;
  isTradeHistoryReturned: boolean;
}

const DownloadCSVButton = ({
  data,
  filename,
  isTradeHistoryReturned,
}: PropsWithChildren<DownloadCSVButtonProps>) => {
  const theme = GlobalStore.useState(s => s.theme);
  const isMobile = useIsMobile();
  if (!isTradeHistoryReturned) {
    return null; //Refactor this so we return soemthing that looks like the button but is disabled
  }

  return (
    <DownloadCSVButtonWrapper>
      <CSVLink data={data} filename={filename}>
        <Text
          size="Small"
          textStyle="Button"
          textCss={css`
            display: flex;
            align-items: center;
            gap: 2px;
            color: ${theme.button.tertiary.text.default};
          `}
        >
          {isMobile ? (
            <DownloadIcon
              stroke={theme.button.tertiary.text.default}
              width={20}
              height={20}
              style={{ marginRight: "8px" }}
            />
          ) : (
            <>
              <DownloadIcon stroke={theme.button.tertiary.text.default} />
              Download
            </>
          )}
        </Text>
      </CSVLink>
    </DownloadCSVButtonWrapper>
  );
};

export default DownloadCSVButton;

export const DownloadCSVButtonWrapper = styled.button`
  background: none;
  border-radius: 20px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  color: ${props => props.theme.button.tertiary.text.default};
  margin-left: auto;
  cursor: pointer;
`;
